const ApplicationStatusEnum = Object.freeze({
    AWAITING_ADVISER_SIGNATURE: 'AWAITING_ADVISER_SIGNATURE',
    AWAITING_INVESTOR_SIGNATURE: 'AWAITING_INVESTOR_SIGNATURE',
    COMPLETE: 'COMPLETE'
});

export default ApplicationStatusEnum;
